import { ComponentType } from 'react';

import TripPlannerChatConversationsPage from './TripPlannerChatConversationsPage';
import TripPlannerChatStatsPage from './TripPlannerChatStatsPage';

type TripPlannerChatTab = {
  path: string;
  title: string;
  component: ComponentType;
};

export const tripPlannerChatTabs: ReadonlyArray<TripPlannerChatTab> = [
  {
    path: '/trip-planner',
    title: 'Chats',
    component: TripPlannerChatConversationsPage,
  },
  {
    path: '/trip-planner/stats',
    title: 'Stats',
    component: TripPlannerChatStatsPage,
  },
];
